/**
 * This code has originally been copied from the openapi-typescript-fetch repository (https://github.com/ajaishankar/openapi-typescript-fetch/tree/main/src),
 * because changes needed to be made to make it work for our schema.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DEFAULT_SHERBERT_BASE_URL } from '../../baseUrl';
import { objectToFormData } from '../objectToFormData';
import { ApiError, } from './types';
/** Whether a method supports a request body */
const supportsBody = (method) => method === 'post' || method === 'put' || method === 'patch' || method === 'delete';
/** Replaces variables in the given endpoint path with actual data from the payload. */
function getPath(path, pathPayload) {
    if (!pathPayload) {
        return path;
    }
    return path.replace(/\{([^}]+)\}/g, (_, key) => encodeURIComponent(pathPayload[key]));
}
/** Creates a query string that can be appended to the request URL. */
function getQuery(queryPayload) {
    if (!queryPayload) {
        return '';
    }
    // remove undefined values
    const definedQueryPayload = JSON.parse(JSON.stringify(queryPayload));
    const queryString = new URLSearchParams(definedQueryPayload).toString();
    return queryString.length ? `?${queryString}` : '';
}
/** Creates a Headers object based on the provided data */
function getHeaders(init, body = {}) {
    const headers = new Headers(init);
    if (!headers.has('Content-Type') && Object.keys(body).length) {
        headers.append('Content-Type', 'application/json');
    }
    if (!headers.has('Accept')) {
        headers.append('Accept', 'application/json');
    }
    return headers;
}
/** Creates a request body from the provided payload */
function getBody(method, bodyPayload, defaultBody) {
    if (!bodyPayload) {
        return undefined;
    }
    // body needs to be a string for fetch,
    // but we also want to remove undefined values from it;
    // JSON.stringify does both of those things
    let definedBodyPayload;
    let defaultBodyObj = {};
    if (bodyPayload instanceof FormData) {
        definedBodyPayload = bodyPayload;
    }
    else if ('file' in bodyPayload) {
        definedBodyPayload = objectToFormData(bodyPayload);
    }
    else {
        if (defaultBody) {
            defaultBodyObj = JSON.parse(defaultBody);
        }
        Object.assign(bodyPayload, defaultBodyObj);
        definedBodyPayload = JSON.stringify(bodyPayload);
    }
    const body = supportsBody(method) ? definedBodyPayload : undefined;
    // if delete or post, don't send body if it's empty
    return (method === 'delete' || method === 'post') && body === '{}' ? undefined : body;
}
/** Merges multiple `RequestInit` objects into one */
export function mergeRequestInits(...args) {
    let finalRequestInit = {};
    const headers = new Headers();
    args.forEach((arg) => {
        if (!arg)
            return;
        finalRequestInit = Object.assign(finalRequestInit, arg);
        new Headers(arg.headers).forEach((value, key) => headers.set(key, value));
    });
    return Object.assign(Object.assign({}, finalRequestInit), { headers });
}
/** Converts the fetcher `Request` object to arguments that can be passed to the native `fetch` */
function getFetchParams(request) {
    var _a, _b;
    const { payload } = request;
    const path = getPath(request.path, payload.path);
    const query = getQuery(payload.queryParams);
    const body = getBody(request.method, payload.body, (_a = request.init) === null || _a === void 0 ? void 0 : _a.body);
    const headers = getHeaders(((_b = request.init) === null || _b === void 0 ? void 0 : _b.headers) || {}, body);
    const url = request.baseUrl + path + query;
    const init = Object.assign(Object.assign({}, request.init), { method: request.method.toUpperCase(), headers,
        body });
    return { url, init };
}
function getResponseData(response) {
    return __awaiter(this, void 0, void 0, function* () {
        const text = yield response.text();
        try {
            return JSON.parse(text);
        }
        catch (e) {
            return text;
        }
    });
}
/** A wrapper over the native `fetch` that converts its result to a fetcher `ApiResponse` format and handles errors */
export function fetchJson(url, init) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(url, init);
        const data = yield getResponseData(response);
        const result = {
            headers: response.headers,
            url: response.url,
            ok: response.ok,
            status: response.status,
            statusText: response.statusText,
            data,
        };
        if (result.ok) {
            return result;
        }
        throw new ApiError(result);
    });
}
/** Executes the provided fetcher request */
function fetchUrl(request) {
    return __awaiter(this, void 0, void 0, function* () {
        const { url, init } = getFetchParams(request);
        const response = yield request.fetch(url, init);
        return response;
    });
}
function fetcher(baseUrl) {
    const globalDefaultInit = {};
    const fetch = fetchJson;
    return {
        configure: (config) => {
            // eslint-disable-next-line no-param-reassign
            baseUrl = config.baseUrl || DEFAULT_SHERBERT_BASE_URL;
        },
        /** Choose an endpoint path to create a fetching function for */
        path: (path) => ({
            /** Choose an HTTP method with which to call the previously chosen endpoint path */
            method: (method) => ({
                /**
                 * Create a fetching function for the previously chosen method-endpoint pair.
                 * For requests with a body, a queryParams argument is used to define which parameters should be used in the URL instead of the body.
                 */
                create: (({ defaultInit } = {}) => (payload, init = {}) => {
                    const mergableInit = typeof defaultInit === 'function' ? defaultInit(init) : defaultInit;
                    return fetchUrl({
                        baseUrl: baseUrl || DEFAULT_SHERBERT_BASE_URL,
                        path: path,
                        method: method,
                        payload,
                        init: mergeRequestInits(globalDefaultInit, mergableInit, init),
                        fetch,
                    });
                }),
            }),
        }),
    };
}
export const Fetcher = {
    for: (baseUrl) => fetcher(baseUrl),
};
//# sourceMappingURL=fetcher.js.map